/* src/app/core/components/inactive-user/inactive-user-modal/inactive-user-modal.component.scss */
/*# sourceMappingURL=inactive-user-modal.component-UAE3KBZP.css.map */
